module.exports = __webpack_public_path__ + "img/post_arrow.863084eb.svg";